<template>
  <v-dialog :value="isActive" persistent :width="options.width">
    <v-card :color="options.color">
      <v-card-title>{{ options.title }}</v-card-title>
      <v-card-text v-if="options.text">
        <!-- v-html 属性 -->
        {{ options.text }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="close_modal(false)" text>取消</v-btn>
        <v-btn @click="close_modal(true)" text>确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "wtk-confirm",
  data: () => ({}),
  computed: {
    isActive() {
      return this.$store.getters["message/confirm"].isActive;
    },
    options() {
      return this.$store.getters["message/confirm"].options;
    },
  },
  methods: {
    close_modal(args) {
      var params = { type: "confirm", args: args };
      this.$store.dispatch("message/hide", params.type);
      this.$store.dispatch("message/callback", params);
    },
  },
};
</script>